import {
  Device,
  DeviceControlUnitsAPIResponse,
} from '../../model/device/device.model';
import { ErrorRestST } from '../../rest/rest.model';

export const nameReducer = 'controlUnit';
export interface ZipDeviceControlUnit {
  deviceId: string;
  deviceName: Device['name'];
  controlUnits: DeviceControlUnitsAPIResponse[] | undefined;
  loading: boolean | undefined;
  error: ErrorRestST | undefined;
}
